import { useGigsterProfilesGigStatsSkillsList } from "@sidegigllc/api/client";
import { useAdminPro } from "api/queries/admin";
import {
  PROfileGigHistorySummary,
  PROfileGigHistorySummarySkeleton,
} from "domains/pros/components/PROfileGigHistorySummary";
import React from "react";
import { PROfileGigHistoryDetailContainer } from "../PROfileGigHistoryDetail";

type PROfileGigHistorySummaryContainerProps = { id: number; preview?: boolean };

export const PROfileGigHistorySummaryContainer: React.FC<PROfileGigHistorySummaryContainerProps> = ({
  id,
  preview,
}) => {
  const { data: pro } = useAdminPro({ id });
  const gigsterProfileId = pro?.gigster_profile?.id;
  const { data } = useGigsterProfilesGigStatsSkillsList(gigsterProfileId ?? 0, {
    query: { enabled: gigsterProfileId != null },
  });

  const entries = Object.fromEntries(
    (data ?? []).map((skill) => [
      skill.skill_name,
      {
        skillId: skill.skill_id,
        count: skill.gigs_worked,
        avgRating: skill.rating,
        avgWage: skill.avg_wage_amount,
        detail: <PROfileGigHistoryDetailContainer proId={id} skillId={skill.skill_id} />,
      },
    ]),
  );

  const count = (data ?? []).reduce((acc, s) => acc + s.gigs_worked, 0);

  return data ? (
    <PROfileGigHistorySummary count={count} entries={entries} expandable={!preview} />
  ) : (
    <PROfileGigHistorySummarySkeleton />
  );
};
